module.exports = __webpack_public_path__ + "img/transaction.847347d5.svg";